import React from "react";
import EditOffIcon from "@mui/icons-material/EditOff";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import Widget from "../widget/Widget";

export const IndividualProgressWidgets = ({ schoolData }) => {
  return (
    <div className="individual-progress-widgets-container flex flex-wrap gap-4">
      <Widget
        title="Exercises not started"
        number={
          <p style={{ color: "#eab80f" }}>{schoolData.total_not_started}</p>
        }
        icon={
          <EditOffIcon
            className="icon"
            style={{
              backgroundColor: "#eab80f",
              color: "white",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Total exercises started"
        number={
          <p style={{ color: "rgb(15,158,234)" }}>{schoolData.total_started}</p>
        }
        icon={
          <EditNoteIcon
            className="icon"
            style={{
              backgroundColor: "rgb(15,158,234)",
              color: "white",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Struggling exercises"
        number={
          <p style={{ color: "#ea271a" }}>{schoolData.total_struggling}</p>
        }
        icon={
          <FitnessCenterIcon
            className="icon"
            style={{
              backgroundColor: "#ea271a",
              color: "white",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Exercises completed"
        number={
          <p style={{ color: "#1b9808" }}>{schoolData.total_completed}</p>
        }
        icon={
          <LibraryAddCheckIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
    </div>
  );
};
